import { useEffect } from 'react';
import { Activity, DirectLine, User } from 'botframework-directlinejs';
import { IDirectLineToken } from '../core/Interfaces';

const chatUser: User = {
  id: 'Aras User',
  name: 'Aras User',
};

const startConversationActivity: Activity = {
  name: 'startConversation',
  type: 'event',
  from: chatUser,
  value: '',
};

export default function usePostStartConversationActivity(
  token: IDirectLineToken | null,
  directLine: DirectLine | null,
) {
  useEffect(() => {
    if (!directLine || !token?.conversationId) {
      return;
    }
    const subscription = directLine.postActivity(startConversationActivity).subscribe({
      error: (err) => console.error('Failed to post activity', err),
    });
    return () => subscription.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token?.conversationId]);
}
